import React from 'react';
import clsx from 'clsx';

import css from './Spinner.module.scss';

interface Props {
    color?: 'blue' | 'white';
}

const Spinner: React.FC<Props> = ({ color = 'blue' }) => (
    <div className={css.container}>
        <div className={clsx(css.spinner, color === 'white' && css.white)} />
    </div>
);

export default React.memo(Spinner);
